"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithResponsiveColumns = void 0;
const ResponsiveColumns_1 = __importDefault(require("./ResponsiveColumns"));
const react_1 = __importDefault(require("react"));
function WithResponsiveColumns(Component) {
    // @ts-ignore
    const Container = (props) => {
        const { columns, noHorizontalPaddings, noPaddings, imageWithTextOverlayBlock, fullWidthLayout } = props;
        return (react_1.default.createElement(ResponsiveColumns_1.default, { columns: columns, noHorizontalPaddings: noHorizontalPaddings, noPaddings: noPaddings, imageWithTextOverlayBlock: imageWithTextOverlayBlock, fullWidthLayout: fullWidthLayout },
            react_1.default.createElement(Component, Object.assign({}, props))));
    };
    return Container;
}
exports.WithResponsiveColumns = WithResponsiveColumns;
exports.default = WithResponsiveColumns;
